import { IOffer, IOffer_Type } from '@bridebook/models/source/models/Suppliers/Offers.types';

const OFFER_TYPE_ORDER = [
  IOffer_Type.bbDiscount,
  IOffer_Type.lateAvailability,
  IOffer_Type.seasonal,
  IOffer_Type.midweek,
  IOffer_Type.custom,
];

export const sortOffersByType = (a: IOffer, b: IOffer) => {
  const idxA = OFFER_TYPE_ORDER.indexOf(a.type || IOffer_Type.custom);
  const idxB = OFFER_TYPE_ORDER.indexOf(b.type || IOffer_Type.custom);
  const safeA = idxA === -1 ? Infinity : idxA;
  const safeB = idxB === -1 ? Infinity : idxB;
  return safeA - safeB;
};
